import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=4494ff92&"
import script from "./LoadingMessage.vue?vue&type=script&lang=js&"
export * from "./LoadingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports